// extracted by mini-css-extract-plugin
export default {"footerBg":"G-z","footerTopLinks":"H-z","footerFeedback":"I-z","footerSocial":"J-z","footerLegalLinks":"K-z","footerIconCards":"L-z","footerBotCopy":"M-z"};